import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from "framer-motion";
import ResetLocation from '../../../helpers/ResetLocation'
import blogPreview from '../../../data/blogPreview';
import './blog-preview.css'

const BlogPreview = () => {
  return (
    <motion.div className="homepage__blog flex-container flex-column"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >

      <h2 className="txt-center pop-font txt-white">Neu im Blog</h2>
      <p className="section-description">
        Frisch, geschmackvoll und vielleicht sogar ein paar gesunde Rezepte – gemacht für das echte, alltägliche Leben. Du musst kein Profi sein! Wir helfen dir, die Freude am Essen auf eine entspannte Art zu feiern.
      </p>
      <section className="homepage__blog-posts">
        {blogPreview.map((post) => (
          <section
            key={post.id}
            className="homepage__blog-post flex-container flex-column"
          >
            <img
              src={post.img}
              alt={post.name}
              width={330}
              height={220}
              loading="lazy"
            />
            <p className="date">{post.date}</p>
            <Link onClick={ResetLocation} to={`/blog/${post.name.toLowerCase().replace(/[^\w\s-]/g, '').replaceAll(' ', '-')}`}>
              <h3 className="pop-font txt-white">{post.name}</h3>
            </Link>
            <p className="homepage__blog-intro">{post.intro}</p>
          </section>
        ))}
      </section>

      <Link
        onClick={ResetLocation}
        to="/blog"
        className="active-button-style txt-white"
      >
        Weitere Beiträge
      </Link>
    </motion.div>

  )
}
export default BlogPreview;
